module.exports = __webpack_public_path__ + "c79018c311a28510d6b9e2dc64e376c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/macha-panel-320.jpg
// module id = 470
// module chunks = 0